export default __webpack_public_path__ + "static/media/diploma.4e8c232d.png";